export default function PopupOverlay({ children, onClose }) {
  return (
    <div className="popup-overlay">
      <div
        className="popup-backdrop"
        onClick={onClose}
      />

      <div className="popup-content">
        {children}
      </div>
    </div>
  );
}